const hoc=(props)=>props.children;

export default hoc;


// WEBPACK FOOTER //
// ./src/Components/HigherOrder/hoc.js